export default __webpack_public_path__ + "/dist/images/logo9.ada7be32799c83818a609e0f78cd77f1.png";